<ng-container *ngIf="baseProject.projectInvoices?.length > 0">
  <mat-card class="top-card mat-elevation-z0 overflowHidden">
    <span *ngIf="showTitle">{{
      collaborative
        ? 'Prijsberekeningen gezamenlijke opdracht'
        : 'Afwijkende prijsberekeningen'
    }}</span>
    <div class="upper-space">
      <mat-checkbox
        [(ngModel)]="divergentPricesOnly"
        (ngModelChange)="divergentPricesOnlyChanged()"
      >
        <span>Enkel onderstaande prijs in rekening brengen</span>
      </mat-checkbox>
    </div>
    <div
      *ngFor="let invoice of baseProject.projectInvoices; let count = count"
      class="upper-space"
    >
      <ip-board-company-invoice
        [placementInvoice]="invoice"
        [multiple]="count > 1"
        [showSave]="showSave"
        [savingLines]="savingLines"
        (save)="save.emit()"
        (saveLines)="saveLines.emit()"
      ></ip-board-company-invoice>
    </div>
  </mat-card>
</ng-container>
